import * as PropTypes from "prop-types";

export const databasePropType = PropTypes.shape({
  areas: PropTypes.object.isRequired,
  indicators: PropTypes.object.isRequired,
  sectors: PropTypes.object.isRequired,
  methods: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired
});

export const dataPropType = PropTypes.shape({
  databases: PropTypes.shape({
    core: databasePropType,
    reportingYear: databasePropType,
    allSectorTotals: databasePropType
  }),
  widgetData: PropTypes.shape({
    theme1: PropTypes.shape({
      currentSpendingBySectorTable: PropTypes.array.isRequired,
      currentSpendingChart: PropTypes.array.isRequired,
      projectedFundingGapsBySectorTable: PropTypes.array.isRequired,
      projectedFundingGapsWithinPublicSectorTable: PropTypes.array.isRequired,
      projectedFundingGapsByGniGroupTable: PropTypes.array.isRequired,
      cumulativeGapBySectorChart: PropTypes.array.isRequired,
      cumulativeGapByGniGroupChart: PropTypes.array.isRequired
    }).isRequired,
    theme2: PropTypes.shape({
      usersByMethodChart: PropTypes.array.isRequired,
      usersBySectorTable: PropTypes.array.isRequired,
      shareOfUsersChart: PropTypes.array.isRequired,
      methodMixWithinSectorChart: PropTypes.array.isRequired
    }).isRequired,
    theme3: PropTypes.shape({
      shareOfUsersWithinPrivateSectorByMethodChart: PropTypes.array.isRequired,
      shareWithinPrivateSectorByGniGroupUserChart: PropTypes.array.isRequired,
      shareWithinPrivateSectorByGniGroupCostChart: PropTypes.array.isRequired
    }).isRequired,
    theme4: PropTypes.shape({
      methodMixOfUseVsCostChart: PropTypes.array.isRequired,
      consumptionCostChart: PropTypes.array.isRequired,
      methodMixOfUseVsCostBySectorChart: PropTypes.array.isRequired,
      shareOfUsersVsCostChart: PropTypes.array.isRequired,
      shareOfConsumptionCostsByMethodChart: PropTypes.array.isRequired,
      shareOfConsumptionCostsVsUsersBySectorChart: PropTypes.array.isRequired
    }).isRequired,
    theme5: PropTypes.shape({
      changeByMethodUserChart: PropTypes.array.isRequired,
      changeInMethodMixChart: PropTypes.array.isRequired,
      changeByGniGroupUserTable: PropTypes.array.isRequired,
      changeByGniGroupUserChart: PropTypes.array.isRequired,
      methodMixChart: PropTypes.array.isRequired,
      changeByMethodCostChart: PropTypes.array.isRequired,
      changeByGniGroupCostTable: PropTypes.array.isRequired,
      changeByGniGroupCostChart: PropTypes.array.isRequired
    }),
    countryExplorer: PropTypes.shape({
      currentChart: PropTypes.array.isRequired,
      projectionChart: PropTypes.array.isRequired
    }),
    annex: PropTypes.shape({
      contraceptionUsersTable: PropTypes.array.isRequired,
      userMethodMixAndShareTable: PropTypes.array.isRequired,
      changeInUsersTable: PropTypes.array.isRequired,
      contraceptionCostTable: PropTypes.array.isRequired,
      costMethodMixAndShareTable: PropTypes.array.isRequired,
      changeInCostTable: PropTypes.array.isRequired,
      contraceptionQuantityTable: PropTypes.array.isRequired,
      quantityMethodShareTable: PropTypes.array.isRequired,
      changeInQuantityTable: PropTypes.array.isRequired
    })
  }).isRequired
});

export const labeledValuesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })
).isRequired;

export const titlesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string.isRequired,
    columnSpan: PropTypes.number.isRequired,
    groupStart: PropTypes.bool,
    groupEnd: PropTypes.bool,
    total: PropTypes.bool
  })
);
